/**
 * Phase5PostDeploymentBody — iter84.71
 *
 * Body of the PRODUCTION-ONLY Phase 5 ("Post-deployment check")
 * collapsible section. Production's Release Ops surface is now just:
 *   1. Hero (Production · Audit & Health) — in the orchestrator.
 *   2. "How to use this tab on production" callout — in the orchestrator.
 *   3. This Phase 5 section:
 *      5.1 Production View read-only card (RunbookInitiationCard in its
 *          prod read-only mode).
 *      5.2 Production health (DeploymentReadinessBanner — auto-flips
 *          `post_deploy:prod_readiness_green` on the active promotion).
 *      5.3 Post-Deploy Auto-Verify (same CollapsibleCard shell as the
 *          health banner — auto-flips `post_deploy:auto_verify_prod`).
 *
 * Phases 0–4 are hidden on production (they're the preview runbook);
 * Phase 5 is hidden on preview (its preview counterpart is Phase 1's
 * sub-step 1.5 — see Phase1PreCommitSafetyBody.jsx).
 */
import { RunbookInitiationCard } from "@/components/site-admin/RunbookPhaseCards";
import DeploymentReadinessBanner from "@/components/site-admin/DeploymentReadinessBanner";
import PostDeployAutoVerifyCard from "@/components/site-admin/PostDeployAutoVerifyCard";

export function Phase5PostDeploymentBody({
    activePromotion,
    setActivePromotion,
    reloadActivePromotion,
    uiMode,
    environment,
    autoFlipGate,
}) {
    return (
        <div className="space-y-6" data-testid="phase5-post-deployment-body">
            {/* 5.1 — Production view (read-only promotion record). */}
            <RunbookInitiationCard
                promotion={activePromotion}
                onUpdated={setActivePromotion}
                onCancelled={() => {
                    setActivePromotion(null);
                    reloadActivePromotion(uiMode);
                }}
                environment={environment}
            />
            {/* 5.2 — Production health. Auto-flips
                `post_deploy:prod_readiness_green` (ok → Approved,
                warn → Waived with reason, fail → stays Pending). */}
            <DeploymentReadinessBanner
                onVerdictResolved={({ overall, warn_count, fail_count }) =>
                    autoFlipGate({
                        section: "post_deploy",
                        itemId: "prod_readiness_green",
                        verdict: overall,
                        summary: { warn_count, fail_count },
                    })
                }
            />
            {/* 5.3 — Post-Deploy Auto-Verify. Verdict auto-flips
                `post_deploy:auto_verify_prod` so FINALIZE (walked from
                preview) stays locked on a red production verdict. */}
            <PostDeployAutoVerifyCard
                autoRun
                onVerdictResolved={({ overall, summary }) =>
                    autoFlipGate({
                        section: "post_deploy",
                        itemId: "auto_verify_prod",
                        verdict: overall,
                        summary,
                    })
                }
            />
        </div>
    );
}
